var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text"},[_vm._v(" 欢迎来到BI系统 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }